// extracted by mini-css-extract-plugin
module.exports = {"bendingTable":"BendingTable_bendingTable__1tutI"};